module.exports = __webpack_public_path__ + "static/agency-banner-786e83ef0f7f5cd78b599e53dd9b0a0f.png";